// Cliente HTTP del framework de rollout (panel comercio). axiosInstance ya estampa
// Authorization + id_comercio; el lambda resuelve identidad desde el JWT.
//
// Estos endpoints NUNCA se esperan en un handler de UI: el hook hidrata en background
// y el outbox los drena fire-and-forget.

import axiosInstance from './axiosInstance';
import type {
  FeatureSwitchResult,
  FeatureTelemetryEvent,
  FeatureVariant,
  FeatureVersionResponse,
} from '@utils/featureRollout/types';

const TELEMETRY_BATCH_MAX = 50;

// GET /v1/feature-version?feature_key=… → resolución vigente para el comercio del JWT.
export async function fetchFeatureVersion(featureKey: string): Promise<FeatureVersionResponse> {
  const { data } = await axiosInstance.get<FeatureVersionResponse>('/v1/feature-version', {
    params: { feature_key: featureKey },
  });
  return data;
}

// PUT /v1/feature-version → cambia/revierte la variante (solo root). No-root devuelve
// { ok:false, reason:'REQUIRES_ROOT' } con 200, así que lo tratamos como resultado, no error.
export async function putFeatureVersion(args: {
  featureKey: string;
  toVariant: FeatureVariant;
  fromVariant?: FeatureVariant;
  trigger?: string;
}): Promise<FeatureSwitchResult> {
  const { data } = await axiosInstance.put<FeatureSwitchResult>('/v1/feature-version', {
    feature_key: args.featureKey,
    to_variant: args.toVariant,
    from_variant: args.fromVariant,
    trigger: args.trigger,
  });
  return { ok: Boolean(data?.ok), reason: data?.reason };
}

// POST /v1/feature-telemetry → batch (<=50) de eventos. Idempotente por event_id (ULID).
export async function postFeatureTelemetry(events: FeatureTelemetryEvent[]): Promise<void> {
  if (events.length === 0) return;
  const batch = events.slice(0, TELEMETRY_BATCH_MAX);
  await axiosInstance.post('/v1/feature-telemetry', { events: batch });
}

export { TELEMETRY_BATCH_MAX };
